import { AnimationFeature } from "./animation/animation.mjs";
import { PressGesture } from "./gestures/press/index.mjs";
import { HoverGesture } from "./gestures/hover/index.mjs";
import { InViewGesture } from "./gestures/in-view/index.mjs";
import { FocusGesture } from "./gestures/focus/index.mjs";
const domAnimation = [
  AnimationFeature,
  PressGesture,
  HoverGesture,
  InViewGesture,
  FocusGesture
];
export {
  domAnimation
};
